var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "550mm",
    height: 2352.745,
    viewBox: "0 0 550 622.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M-2114.147-361.216h-469.9l44.053 477.705 190.87 54.134 190.871-54.134z",
    style: {
      fill: "#e6a329",
      strokeWidth: 0.26458332
    },
    transform: "translate(3024.528 422.79) scale(1.17046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2349.123-322.296v452.438l154.649-43.815 37.623-408.623z",
    style: {
      fill: "#f1bf22",
      strokeWidth: 0.26458332
    },
    transform: "translate(3024.528 422.79) scale(1.17046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2226.092-263.69h-237.781l-16.563 178.858.344-1.112h202.01l-6.589 75.671-64.452 18.547-65.405-18.838-3.916-45.8h-59.373l8.467 91.52 120.227 34.131 120.28-34.13 16.562-179.627h-214.392l2.752-59.848h148.749l2.222 34.29h59.902z",
    style: {
      fill: "#fff",
      strokeWidth: 0.26458332
    },
    transform: "translate(3024.528 422.79) scale(1.17046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2349.07-263.69h-114.803l-16.563 178.858.344-1.112h131.022v-58.34h-69.242l2.752-59.85h66.49zm-69.242 207.327h-59.505l8.467 91.466 120.227 34.079V8.327l-65.405-18.89z",
    style: {
      fill: "#ebebeb",
      strokeWidth: 0.26458332
    },
    transform: "translate(3024.528 422.79) scale(1.17046)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.7b976761bde0d5f5e75f1ded0e4bca15.svg";
export { ForwardRef as ReactComponent };